export default "__VITE_ASSET__CpO3xVAN__"